import { connect } from 'react-redux';
// types
import { State } from 'widgets/friends-referral/root/root.reducers';
import { IInvitationStoreProps } from './invitation.types';
// components
import { InvitationWithTranslations } from './invitation.component';
// utils
import { acceptInvitation } from '../friends-referral/friends-referral-store';

const mapStateToProps = (state: State): IInvitationStoreProps => ({
    conversion: state.friendsReferral.campaignInfo.conversion,
    invitationInfo: state.friendsReferral.invitationInfo,
    dataFormat: state.config.friendsReferral?.dataFormat,
    shouldInheritStyles: state.config.shouldInheritStyles
});

const mapDispatchToProps = { acceptInvitation };

export default connect(mapStateToProps, mapDispatchToProps)(InvitationWithTranslations);
